export const backend = [
  {
    skill: "Node Js",
    level: "Intermediate",
  },
  {
    skill: "MongoDB",
    level: "Experienced",
  },
  {
    skill: "Express",
    level: "Intermediate",
  },
  {
    skill: "API",
    level: "Experienced",
  },
  {
    skill: "Postman",
    level: "Experienced",
  },
  {
    skill: "Python",
    level: "Intermediate",
  },
];

export const frontend = [
  {
    skill: "HTML",
    level: "Experienced",
  },
  {
    skill: "CSS",
    level: "Intermediate",
  },
  {
    skill: "Javascript",
    level: "Experienced",
  },
  {
    skill: "Bootstrap",
    level: "Intermediate",
  },
  {
    skill: "Tailwind",
    level: "Experienced",
  },
  {
    skill: "React",
    level: "Experienced",
  },
];
